import { css } from '@emotion/react'
import { memo, useCallback } from 'react'
import { openTokensDrawer } from '../../app-state/modals/state.drawer'
import i18n from '../../utilities/i18n'
import Button from '../Buttons/Button'
import { getThemeSpacing } from '../styles/appTheme'

const rootStyles = css({
    minWidth: 92,
    maxWidth: 92,
    marginLeft: getThemeSpacing(1),
    marginRight: getThemeSpacing(1),
})

const ButtonBuy = () => {
    const label = i18n.t('buttons.buyTokens')
    const handleOnClick = useCallback(() => openTokensDrawer(), [])
    return (
        <Button
            title={i18n.t('buttons.purchaseTokens')}
            data-testid="Button__Buy"
            onClick={handleOnClick}
            size="small"
            css={rootStyles}
        >
            {label}
        </Button>
    )
}

export default memo(ButtonBuy)
